import { ButtonHTMLAttributes, ElementType, ReactNode } from "react";
import { twMerge } from 'tailwind-merge'

interface ElementProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    icon?: ElementType,
    text?: string,
    variant?: "primary" | "secondary" | "onlyicon" | "none" | "primary-variant",
    children?: ReactNode,
}

export function Element({ icon: Icon, text, variant = "primary", children, ...rest }: ElementProps) {
    return (
        <button
            type="button"
            {...rest}
            className={twMerge(
                "tw-font-bold tw-text-lg",
                variant == "primary" && "tw-pb-0.5 tw-pt-1 tw-rounded-lg tw-min-w-[200px] tw-max-w-[230px] tw-text-[#fff] tw-bg-gradient-to-r tw-from-[#E13441] tw-to-[#FAAE2E] hover:tw-opacity-90", 
                variant == "primary-variant" && "tw-pb-0.5 tw-pt-1 tw-rounded-lg tw-min-w-[200px] tw-max-w-[230px] tw-text-[#fff] tw-bg-[#FAAE2E] hover:tw-opacity-90", 
                variant == "secondary" && "tw-pb-0.5 tw-pt-1 tw-rounded-lg tw-min-w-[200px] tw-max-w-[230px] tw-bg-transparent tw-border tw-border-red-500 hover:tw-bg-slate-100", 
                variant == "onlyicon" && "tw-rounded-lg tw-pb-0 tw-pt-0", 
                variant == "none" && "", 
                rest.disabled && 'hover:tw-opacity-100',
                rest.className
            )}
        >
            {children}
            {Icon && <Icon />}
        </button>
    )
}